import { render } from "./ContentsBundleIndex.vue?vue&type=template&id=363c6f7d&scoped=true&ts=true"
import script from "./ContentsBundleIndex.vue?vue&type=script&lang=ts"
export * from "./ContentsBundleIndex.vue?vue&type=script&lang=ts"

import "./ContentsBundleIndex.vue?vue&type=style&index=0&id=363c6f7d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363c6f7d"]])

export default __exports__